import { MessageResponse } from "@/generated-api/models/MessageResponse";
import sentIcon from "../../assets/sent-check.svg";
import readIcon from "../../assets/read-check.svg";

const formatTime = (timestamp: string) => {
  const date = new Date(timestamp);
  return date.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

export default function TimeReadStatus({
  counterparty,
  message,
  textColor,
}: {
  counterparty: boolean;
  message: MessageResponse;
  textColor?: string;
}) {
  return (
    <span
      className={`text-xs ${
        textColor || (counterparty ? "text-gray-500" : "text-gray-400")
      } absolute bottom-0 right-0 whitespace-nowrap flex items-center gap-1 select-none`}
    >
      {formatTime(message.sent_at)}
      {!counterparty && (
        <span className="flex">
          {message.sender_id === "self_pending" ? null : message.read_at ? (
            <img src={readIcon} className="h-4 w-4" />
          ) : (
            <img src={sentIcon} className="h-3 w-3" />
          )}
        </span>
      )}
    </span>
  );
}
